<div [class]="'alert-container rounded-md py-3.5 px-4 ' + class">
  <rd-shared-icon
    *ngIf="icon"
    class="alert-icon mr-2 mt-0.5"
    [iconSymbol]="'icon-' + icon"
    [iconTheme]="iconTheme"></rd-shared-icon>
  <ng-content></ng-content>
</div>
